import React from 'react';
import { Link } from 'react-router-dom';
import img from '../../Assets/snakedev-dribbble_4x.webp'

const Navbar = () => {
    const menuItems = <>
        <li className='font-bold'><Link to='/'>Home</Link></li>
        <li className='font-bold'><Link to='/about'>About Me</Link></li>
        <li className='font-bold'><Link to='/project'>Projects</Link></li>
        <li className='font-bold'><Link to='/blog'>Blog</Link></li>
        <li className='font-bold'><Link to='/contact'>Contact</Link></li>
    </>
    return (
        <div>
            <div className="navbar  shadow-lg">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            {menuItems}
                        </ul>
                    </div>
                    <Link className="btn btn-ghost normal-case text-2xl text-orange-800 font-extrabold" to='/'><img className='w-10 h-10 mr-1' src={img} alt="" />    Dev</Link>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal px-1">
                        {menuItems}
                    </ul>
                </div>
                {/* <div className="navbar-end">
                    <Link to='/' className="btn">Get started</Link>
                </div> */}
            </div>
        </div>
    );
};

export default Navbar;